var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 155,
    viewBox: "0 0 255 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 140.615,
    y1: 2,
    x2: 140.615,
    y2: 52,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 149.77,
    y1: 16,
    x2: 149.77,
    y2: 51,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 131.461,
    y1: 8,
    x2: 131.461,
    y2: 52.375,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 41.875,
    y2: -2,
    transform: "matrix(0 -1 -1 6.60225e-07 156.924 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 122.309,
    y1: 14,
    x2: 122.309,
    y2: 51.625,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 29.38,
    y2: -2,
    transform: "matrix(0 -1 -1 1.59219e-07 166.076 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 113.154,
    y1: 19,
    x2: 113.154,
    y2: 52.125,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 23,
    x2: 104,
    y2: 51.625,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 94.8457,
    y1: 27,
    x2: 94.8457,
    y2: 52.25,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 85.6914,
    y1: 35,
    x2: 85.6914,
    y2: 52.375,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 76.5391,
    y1: 38,
    x2: 76.5391,
    y2: 52,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 14.875,
    y2: -2,
    transform: "matrix(0 -1 -1 1.16109e-08 175.23 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 67.3848,
    y1: 40,
    x2: 67.3848,
    y2: 51.75,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 12.625,
    y2: -2,
    transform: "matrix(0 -1 -1 1.58375e-08 193.539 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 58.2305,
    y1: 44,
    x2: 58.2305,
    y2: 52.375,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 10.375,
    y2: -2,
    transform: "matrix(0 -1 -1 2.38704e-08 184.385 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 49.0762,
    y1: 45,
    x2: 49.0762,
    y2: 52.25,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 9.25,
    y2: -2,
    transform: "matrix(0 -1 -1 1.16109e-08 211.846 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 39.9238,
    y1: 47,
    x2: 39.9238,
    y2: 52,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 7,
    y2: -2,
    transform: "matrix(0 -1 -1 1.16109e-08 202.691 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 30.7695,
    y1: 48,
    x2: 30.7695,
    y2: 51.875,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 5.875,
    y2: -2,
    transform: "matrix(0 -1 -1 5.23912e-09 230.154 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6152,
    y1: 49,
    x2: 21.6152,
    y2: 51.75,
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 4.75,
    y2: -2,
    transform: "matrix(0 -1 -1 5.23912e-09 221 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 2.5,
    y2: -2,
    transform: "matrix(0 -1 -1 1.16109e-08 239.309 54)",
    stroke: "#A1A1A1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.4c59a809006f7b2b91a84451ab0021af.svg";
export { ForwardRef as ReactComponent };